<template lang="html">

  <section class="banner-contacta">

    <div class="container row-end">

      <div class="contenedor-texto">

        <h2>
          <span class="-orange">Contacta</span>
          <span></span>
        </h2>

        <div class="textos">
          <h4>¿Tienes alguna otra pregunta o no encuentras lo que buscas?</h4>
          <p>Escríbenos y no te quedes con ninguna duda. Nuestro equipo atenderá tu consulta y te recomendará siempre la tarifa que mejor se adapta a tus necesidades.</p>
          <router-link class="btn -degree" :to="$t('enlaces.contacto')" title="Ir al formulario" aria-label="Ir al formulario">Ir al formulario</router-link>
        </div>

      </div>

    </div>

    <img src="/static/img/fondo-cable.webp" class="fondo-cable">

  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-acceso-contacto',
  }
</script>





// WEBPACK FOOTER //
// src/components/parts/banner-acceso-contacto.vue